import { css } from "@repo/styled-system/css";

/**
 * Shared bordered button for the thin `/ops` back-office surface. The operator panels were rendering
 * raw unstyled `<button>`s (text only), which read as plain links; this gives every action a border,
 * padding, hover and disabled state so the controls are legible.
 */
export const opsButton = css({
  px: "3",
  py: "1.5",
  fontSize: "sm",
  fontWeight: "medium",
  borderWidth: "1px",
  borderColor: "border.default",
  rounded: "md",
  bg: "bg.default",
  color: "fg.default",
  cursor: "pointer",
  _hover: { bg: "bg.subtle" },
  _disabled: { opacity: "0.5", cursor: "not-allowed" },
});
